import React, { createContext, useContext, useState, ReactNode } from "react";

export interface KitchenUser {
  id: string;
  name: string;
  email: string;
  role: string;
  restaurantId: string;
}

interface KitchenAuthContextType {
  user: KitchenUser | null;
  setUser: React.Dispatch<React.SetStateAction<KitchenUser | null>>;
  token: string | null;
  setToken: React.Dispatch<React.SetStateAction<string | null>>;
  login: (payload: { user: KitchenUser; token?: string }) => void;
  logout: () => void;
}

const KitchenAuthContext = createContext<KitchenAuthContextType | undefined>(
  undefined
);

interface KitchenAuthProviderProps {
  children: ReactNode;
}

export const KitchenAuthProvider: React.FC<KitchenAuthProviderProps> = ({
  children,
}) => {
  const [user, setUser] = useState<KitchenUser | null>(null);
  const [token, setToken] = useState<string | null>(null);

  const login = (payload: { user: KitchenUser; token?: string }) => {
    setUser(payload.user);
    setToken(payload.token ?? null);
  };

  const logout = () => {
    setUser(null);
    setToken(null);
  };

  return (
    <KitchenAuthContext.Provider
      value={{ user, setUser, token, setToken, login, logout }}
    >
      {children}
    </KitchenAuthContext.Provider>
  );
};

export const useKitchenAuth = (): KitchenAuthContextType => {
  const context = useContext(KitchenAuthContext);
  if (!context) {
    throw new Error("useKitchenAuth must be used within a KitchenAuthProvider");
  }
  return context;
};
